import React from "react";

import './TransactionList.css';

import Transaction from "../../components/transaction/Transaction";
import { useSelector } from "react-redux";
import { selectUser } from "../home/userSlice";

export default function TransactionList({type, transactions, accountBalance}) {
    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;

    if (transactions.length === 0) {
        return;
    }

    let pendingTotal = 0;
    if (type === 'pending') {
        transactions.forEach(transaction=> {
            if (transaction.type === 'debit') {
                pendingTotal -= transaction.amount;
            } else {
                pendingTotal += transaction.amount;
            }
        });
    }
    return (
        <div>
            <table>
                <colgroup>
                    <col className="groupOne" />
                    <col className="groupTwo" />
                    <col className="groupOne" />
                    <col className="groupOne" />
                    <col className="groupOne" />
                    {userRole === 'USER' ? "" : <col className="groupOne" />}
                </colgroup>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th>Balance</th>
                        {userRole === 'USER' ? "" : <th>Edit</th>}
                    </tr>
                </thead>
                <tbody>
                    {transactions.map((transaction) => {
                        return <Transaction transaction={transaction} key={transaction.id} />
                    })}
                </tbody>
            </table>
            {type === 'pending' ? <h4>Pending Total: ${pendingTotal.toFixed(2)}</h4> : ''}
        </div>
    )
}